import React from "react";
import MultiSelect from "react-multi-select-component";

const MutiSelectableField = ({
  label,
  options,
  selectAllLabel,
  setSelected,
  selected,
  filterOptions,
}) => {
  return (
    <div>
      <label>{label}</label>
      <MultiSelect
        filterOptions={filterOptions}
        options={options}
        value={selected}
        onChange={setSelected}
        labelledBy={"Select"}
        selectAllLabel={selectAllLabel}
        hasSelectAll={true}
        // filterOptions={filterOptions}
      />
    </div>
  );
};

export default MutiSelectableField;
